const createPersonalDataPayload = Object.freeze({
  firstName: null,
  lastName: null,
  maternalLastName: null,
  professionId: null,
  positionCode: null,
  workActivityId: null,
  countryCode: null,
  email: null,
  phone: null,
  address: null,
  taxDeclaration: null,
  executiveCode: null,
  idPreferredOffice: null,
});

export const genPayloadToRegisterPersonalData = (personalData) => {
  const payload = { ...createPersonalDataPayload };

  payload.firstName = personalData.firstName.value.replace(/  +/g, ' ').trim();
  payload.lastName = personalData.lastName.value.replace(/  +/g, ' ').trim();
  payload.maternalLastName = personalData.maternalLastName.value.replace(/  +/g, ' ').trim();
  payload.professionId = personalData.profession.value.id;
  payload.positionCode = personalData.position.value.codigo;
  payload.workActivityId = personalData.workActivity.value.id;
  payload.countryCode = personalData.countryNationality.value.codigo;
  payload.email = personalData.email.value.toLowerCase();
  payload.phone = personalData.phone.value;
  payload.address = {
    ...personalData.address.value,
    anotherData: personalData.address.anotherData,
  };
  payload.taxDeclaration = personalData.taxDeclaration.value;
  payload.executiveCode = personalData.executiveCode.value;
  payload.idPreferredOffice = personalData.preferredOffice.value.id;

  return payload;
};

export default createPersonalDataPayload;
